import * as z from "zod/v4";

export const updateCommentsoldVariantBin = {
  name: "updateCommentsoldVariantBin" as const,

  input: z.object({
    productId: z.string().describe("The CommentSold product ID"),
    variantId: z.string().describe("The CommentSold variant ID"),
    binValue: z.string().describe("The bin/location value to set"),
  }),

  output: z.object({
    success: z.boolean().describe("Whether the update was successful"),
    errors: z
      .array(z.string())
      .optional()
      .describe("Any errors that occurred during the update"),
  }),
};
